import React, {useState} from "react";
import {Slider, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./ManualScore.css";

const ManualScoreEducation = ({updateScore, cvScore}) => {
    const [score, setScore] = useState(cvScore);

    const marks = [
        {
            value: 10,
            label: 'max 10',
        },
    ];

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setScore((prev) => ({
            ...prev,
            [name]: value,
        }));
        updateScore("educationScore", {...score, [name] : value})
    }

    return (
        <Box className={"scoringBox"} data-testid={"manualScoreBox"}>
            <Grid container padding={2} spacing={2}>
                <Grid item xs={12}>
                    <h3>
                        Education
                    </h3>
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Relevant Education
                    </Typography>
                    <Slider
                        maxWidth
                        style={{color: "#FF6600"}}
                        min={0}
                        step={1}
                        max={10}
                        value={score?.releventEducation}
                        data-testid={"relevantEducation"}
                        name={"releventEducation"}
                        valueLabelDisplay="auto"
                        marks={marks}
                        onChange={(e) => {handleChange(e)}}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Good completion time
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        step={1}
                        max={10}
                        data-testid={"completionTime"}
                        value={score?.completionTime}
                        name={"completionTime"}
                        valueLabelDisplay="auto"
                        marks={marks}
                        onChange={(e) => {handleChange(e)}}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>
                <Grid item xs={12}/>
            </Grid>
        </Box>
    )
}
export default ManualScoreEducation;